import { TemplatesView as ReactTemplatesView } from 'src/views/menus/templates';

const AnalyticsDecorate = require('../../../analytics/decorate');

module.exports = AnalyticsDecorate(require('./analytics/view'), Backbone.View.extend({
  class: 'sub-category template',

  render: function () {
    ReactTemplatesView.mountApp();
  }
}));
